<template>
    <div class="profile">
         <PageHeader title="CV Builder"/>
         <SystemMessage v-if="!loading && error" :message="errorMessage"/>
      <div v-if="!loading && !error" class="divider">
        <div class="cv-viewer">
            <LoadingIndicator message="Loading Preview" v-if="loading"/>
            <CVViewer :cv="cvInformation" v-if="!loading"/>
        </div>
        <div class="cv-builder">   
            <LoadingIndicator message="Loading Editor" v-if="loading"/>   
            <CVBuilder v-if="!loading" :cv="cvInformation"/>
        </div>
      </div>
       
        
    </div>
<CustomConfirmationMessageModal :button-label="modalButtonLabel"
 :title="modal.caption"
 :body="modal.message"
 :close-modal="() => closeModal()"
 :modal-id="modalId"/>   
</template>
<script>
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import CustomConfirmationMessageModal from '@/components/modals/CustomConfirmationMessageModal.vue';
import Modal from 'bootstrap/js/dist/modal';
import SearchBox from '../components/SearchBox.vue';
import CVBuilder from '../views/ProfileView/CVBuilder.vue';
import CVViewer from './ProfileView/CVViewer.vue';
import PageHeader from '@/components/Utility/PageHeader.vue';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
export default {
    components: {
        CVBuilder, 
        SearchBox, 
        CVViewer,
        LoadingIndicator,
        CustomConfirmationMessageModal,
        PageHeader,
        SystemMessage
    },
    data(){
        return{
            modal:{
                caption:"",
                message:""
            },
            confirmModal: null,
            loading:false,
            error:false,
            errorMessage:"Unable to load CV Information. Please try refreshing the page",
            modalButtonLabel:'Close',
            modalId:"cvBuilder"
            
        }
    },
    computed:{
      cvInformation(){
        return this.$store.getters["cvbuilder/getCVInformation"];
      }
    },
    async mounted(){
      this.confirmModal = new Modal(document.getElementById(`${this.modalId}`))
      this.loading = true;
      this.error = false;
      await this.getCVInformationAsync();
      this.loading = false;
    },
    methods:{
      async getCVInformationAsync(){
        try{
        await this.$store.dispatch('cvbuilder/setCVInformationAsync');
        }catch(e){
            this.loading = false;
            this.error = true;
            if(!e.requireSubscription){
              this.errorMessage = e.message || "Something went wrong. Please try later";
            }
        }
      },
      closeModal(){
        this.confirmModal.hide();
        },
      showModal(){
        this.confirmModal.show();
      }
    }
}
</script>
<style scoped>
    
  .profile{
    margin-top:1rem;
  }

  .divider{
    display: grid;
    grid-template-columns: repeat(12,1fr);
    column-gap:0rem;
  }

  .cv-viewer{
    grid-column:1/8;
    /* border: 1px solid black; */
  }

   .cv-builder{
    grid-column:8/13;
  }

  @media(max-width:768px){
  .cv-viewer{
    display:none;
  }

  .cv-builder{
    grid-column:1/13;
    /* border: 1px solid black; */
  }


  
  }
</style>